import React from "react";

const Footer = () => {
  const socialLinks = [
    { href: "https://www.instagram.com/studylinkclasses_indore?igsh=MTh6ZGJtMGk0cXVmYQ==", img: "/assets/img/instagram.png", alt: "Instagram" },
    { href: "https://www.facebook.com/", img: "/assets/img/facebook.png", alt: "Facebook" },
    { href: "https://wa.me/917999061255", img: "/assets/img/Whatsapp.png", alt: "WhatsApp" },
    { href: "https://www.youtube.com/@Studylinkclasses", img: "/assets/img/twitter.png", alt: "YouTube" },
    { href: "https://t.me/studylinkclasses", img: "/assets/img/phone.png", alt: "Telegram" },
  ];

  return (
    <footer style={{ background: '#222', color: '#ccc', paddingTop: 40 }}>
      <div className="container">
        <div className="row" style={{ gap: '30px 0', paddingBottom: 30 }}>

          {/* Brand */}
          <div className="col-12 col-md-4">
            <img src="/assets/img/logo_1.png" alt="Study-Link Coaching Classes" style={{ width: 80, marginBottom: 14 }} />
            <p style={{ fontSize: 14, lineHeight: 1.8, color: '#aaa' }}>
              Study-Link Coaching Classes — your trusted academic partner in Indore since 2014.
              Offering CBSE/ICSE tutoring, SSC, Commerce, Science & entrance exam coaching.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-6 col-md-2">
            <h6 style={{ color: '#fff', fontWeight: 700, marginBottom: 14, textTransform: 'uppercase', fontSize: 13 }}>Quick Links</h6>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                { label: 'Home', href: '/' },
                { label: 'About Us', href: '/about-us' },
                { label: 'Courses', href: '/courses' },
                { label: 'Our Services', href: '/our-services' },
                { label: 'Gallery', href: '/gallery' },
                { label: 'Contact Us', href: '/contact-us' },
              ].map((l) => (
                <li key={l.label} style={{ marginBottom: 8 }}>
                  <a href={l.href} style={{ color: '#aaa', fontSize: 14, textDecoration: 'none' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#009999'}
                    onMouseLeave={e => e.currentTarget.style.color = '#aaa'}>
                    › {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Courses */}
          <div className="col-6 col-md-2">
            <h6 style={{ color: '#fff', fontWeight: 700, marginBottom: 14, textTransform: 'uppercase', fontSize: 13 }}>Courses</h6>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['SSC', 'Commerce', 'Science', 'CBSE / ICSE', 'B.Com / B.Sc', 'Entrance Exams'].map((c) => (
                <li key={c} style={{ marginBottom: 8 }}>
                  <a href="/courses" style={{ color: '#aaa', fontSize: 14, textDecoration: 'none' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#009999'}
                    onMouseLeave={e => e.currentTarget.style.color = '#aaa'}>
                    › {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-12 col-md-4">
            <h6 style={{ color: '#fff', fontWeight: 700, marginBottom: 14, textTransform: 'uppercase', fontSize: 13 }}>Contact Us</h6>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: 12, display: 'flex', gap: 10 }}>
                <span style={{ color: '#009999', fontSize: 16 }}>📍</span>
                <span style={{ color: '#aaa', fontSize: 14, lineHeight: 1.7 }}>
                  72, Ahilya Nagar, Scheme No. 51,<br />
                  100 Feet Road, Sangam Nagar,<br />
                  Indore, Madhya Pradesh - 452006
                </span>
              </li>
              <li style={{ marginBottom: 12, display: 'flex', gap: 10 }}>
                <span style={{ color: '#009999', fontSize: 16 }}>📞</span>
                <a href="tel:+917999061255" style={{ color: '#aaa', fontSize: 14, textDecoration: 'none' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#009999'}
                  onMouseLeave={e => e.currentTarget.style.color = '#aaa'}>
                  +91 7999061255
                </a>
              </li>
              <li style={{ display: 'flex', gap: 10 }}>
                <span style={{ color: '#009999', fontSize: 16 }}>🌐</span>
                <a href="https://studylinkclassesedu.in" style={{ color: '#aaa', fontSize: 14, textDecoration: 'none' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#009999'}
                  onMouseLeave={e => e.currentTarget.style.color = '#aaa'}>
                  studylinkclassesedu.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ borderTop: '1px solid #333', padding: '16px 0' }}>
          <div className="row align-items-center">
            <div className="col-12 col-md-6 text-center text-md-left mb-2 mb-md-0">
              <p style={{ marginBottom: 0, fontSize: 13, color: '#888' }}>
                &copy; {new Date().getFullYear()} All Rights Reserved.{' '}
                <a href="https://webseller.in" target="_blank" rel="noopener noreferrer"
                  style={{ color: '#009999', fontWeight: 600, textDecoration: 'none' }}>Webseller</a>
              </p>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
              <ul className="list-unstyled d-flex align-items-center mb-0" style={{ gap: 12 }}>
                {[
                  { href: 'https://www.instagram.com/studylinkclasses_indore?igsh=MTh6ZGJtMGk0cXVmYQ==', img: '/assets/img/instagram.png', alt: 'Instagram' },
                  { href: 'https://www.facebook.com/', img: '/assets/img/facebook.png', alt: 'Facebook' },
                  { href: 'https://wa.me/917999061255', img: '/assets/img/Whatsapp.png', alt: 'WhatsApp' },
                ].map((s) => (
                  <li key={s.alt}>
                    <a href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.alt}>
                      <img src={s.img} alt={s.alt} style={{ width: 32, height: 32, objectFit: 'contain' }} />
                    </a>
                  </li>
                ))}
                <li>
                  <a href="https://www.youtube.com/@Studylinkclasses" target="_blank" rel="noopener noreferrer" aria-label="YouTube"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, background: '#FF0000', borderRadius: '50%', textDecoration: 'none', fontSize: 14 }}>
                    ▶
                  </a>
                </li>
                <li>
                  <a href="https://t.me/studylinkclasses" target="_blank" rel="noopener noreferrer" aria-label="Telegram"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, background: '#0088cc', borderRadius: '50%', textDecoration: 'none', fontSize: 16 }}>
                    ✈
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
